var exports = {
  "zT": "labelNameText__xVR7LL",
  "uV": "reasonText__sCeXXi",
  "fz": "labelColorBox__EppFet",
  "Se": "archivedLabelContent__0BK94x",
  "we": "archivedLabelIcon__diIaSA",
  "Cp": "labelPickerContainer__43axeS",
  "S2": "labelPickerItem__pFwHAY",
  "LU": "createLabelNoMatchList__iTh68e",
  "v9": "createLabelButton__sdw1Ji",
  "QT": "inlineCreateList__-G3Ahe",
};

module.exports = exports;
